// extracted by mini-css-extract-plugin
export default {"newsContainer":"New_newsContainer__sZuH3","imgContainer":"New_imgContainer__QBP6r","newsInfo":"New_newsInfo__PfP3a","newsButton":"New_newsButton__FTp-W"};